class userClientDetailsController {
  constructor() {
    "ngInject"
    
  }
  
  
  
}

export default userClientDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-client-details/user-client-details.controller.js
 **/